import { FollowGreenLoading } from 'app/components';
import { Suspense } from 'react';

const FollowGreenSuspense = ({ children }) => {
  return <Suspense fallback={<FollowGreenLoading />}>{children}</Suspense>;
};

export default FollowGreenSuspense;
